import Image, { ImageProps } from 'next/image';
import * as S from './styles';
import { CSSProperties, useTheme } from 'styled-components';
import { useMemo, useState } from 'react';

export type TamanhosCartaz = 'extraPequeno' | 'pequeno' | 'medio' | 'grande';
export type CartazProps = Omit<ImageProps, 'width' | 'height'> & {
  $tamanho: TamanhosCartaz;
  style?: CSSProperties;
};

export default function Cartaz(props: CartazProps) {
  const { $tamanho, alt, style, ...rest } = props;

  const theme = useTheme();

  const temImagem = useMemo(
    () => props.src != null && props.src !== '',
    [props.src],
  );

  const [erro, setErro] = useState(false);

  return (
    <S.Container $tamanho={$tamanho} $temImagem={temImagem} style={style}>
      {temImagem && !erro ? (
        <Image
          {...rest}
          onError={() => setErro(true)}
          alt={alt}
          priority
          fill
          sizes={`${theme.tamanhoCartaz.width[$tamanho]}px`}
          style={{
            objectFit: 'cover',
            borderRadius: theme.radius[2],
          }}
        />
      ) : null}
    </S.Container>
  );
}
